import { DateTime } from 'luxon';
import { ScopeType } from '../../enums/scope-types.enum';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import {
	ClientScopedPermissionsInterface,
	ProjectScopedPermissionsInterface,
} from '../../interfaces/scoped-permissions';
import { Guid } from '../guid';
import { ObjectState } from '../../enums/objectState.enum';

export class ScopedPermissionsConfig implements IConfigObjectBase {
	id: string = Guid();
	name = '';
	description?: string;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	userID = '';
	scopeID = '';
	scopeType: ScopeType = ScopeType.Client;
	isOwner = false;
	permissions: ClientScopedPermissionsInterface | ProjectScopedPermissionsInterface = {} as any;
	objectState?: ObjectState | undefined;

	constructor(init?: Partial<ScopedPermissionsConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
